<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Número</th>
        <th scope="col" class="border-0">Cliente</th>
        <th scope="col" class="border-0 text-center">Criado em</th>
        <th scope="col" class="border-0 text-center">Enviado</th>
        <th scope="col" class="border-0">Status</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in quotations" :key="row.id" class="align-items-center">
        <td class="td-1">{{ row.reference_no }}</td>
        <td class="td-5 link">
          <d-link :to="{ name: 'admin-quotation-edit', params: { quotationId: row.id }}">{{ row.customer.name }}</d-link>
        </td>
        <td class="td-2 text-center">{{ row.f_created_at }}</td>
        <td class="td-1 text-center">
          <i class="fas fa-info-circle" :id="'tooltip-'+index"></i>
          <d-tooltip :target="'#tooltip-'+index" container=".tooltip-container">
              <p class="m-0 tooltip-date"><i class="fas fa-envelope"></i> {{ row.sent_mail_at }}</p>
              <p class="m-0 tooltip-date"><i class="fab fa-whatsapp"></i> {{ row.sent_whatsapp_at }}</p>
          </d-tooltip>
        </td>
        <td class="td-3 min-select">
          <d-select v-model="row.status" class="form-control-sm" @change="changeStatus($event, index)">
            <option :value="option.slug" v-for="(option, index) in statusOptions" :key="index">{{ option.name }}</option>
          </d-select>
        </td>
        <td class="td-4">
          <quotation-buttons :quotation.sync="row" @update:quotation="forceReload(index, row)"></quotation-buttons>
        </td>
      </tr>
      <tr v-if="quotations.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum orçamento.</td>
      </tr>
    </tbody>
    <mark-as-sentModal :quotation-id="selectedQuotation" :status="newStatus"/>
    <import-modals/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import MarkAsSentModal from '_modules/quotation/components/modal/MarkAsSentModal.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import QuotationService from '_services/rest/modules/quotation';
import { STATUS_OPTIONS, _DELETE_QUOTATION_ } from './QuotationModel';

export default {
  name: 'customer-table',
  components: {
    ImportModals,
    MarkAsSentModal,
    QuotationButtons,
  },
  props: {
    quotations: {
      type: Array,
    },
  },
  data() {
    return {
      statusOptions: STATUS_OPTIONS,
      selectedQuotation: null,
      newStatus: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    openChoseModal(newStatus, quotation) {
      this.selectedQuotation = quotation.id;
      this.newStatus = newStatus;
      this.setToggle({ type: 'mark_as_sent_modal', bool: true });
    },
    changeStatus(newStatus, index) {
      if (newStatus === 'pending' && this.quotations[index].status === 'open') {
        return this.openChoseModal(newStatus, this.quotations[index]);
      }
      return this.updateStatus(newStatus, index);
    },
    updateStatus(newStatus, index) {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updateStatus(this.quotations[index].id, newStatus)
        .then(response => {
          this.activeAlert({ message: 'Status do orçamento alterado com sucesso', theme: 'success' });
          this.quotations[index] = response;
          this.forceReload();
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    forceReload(param, quotation) {
      this.quotations[param] = quotation;
      this.$forceUpdate();
    },
  },
  mounted() {
    Events.$on(_DELETE_QUOTATION_, quotation => {
      this.selectedQuotation = quotation.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
  .overlay {
    opacity: 0;
    cursor: pointer;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
.align-items-center {
  td {
    vertical-align: middle;
  }
  .btn-sm { padding: 0.4rem 0.7rem; }
}
.td {
  &-1 {
    width: 1%;
    min-width: 20px;
  }
  &-2 {
    width: 3%;
  }
  &-3 {
    width: 7%;
    min-width: 120px;
  }
  &-4 {
    width: 8%;
    min-width: 330px;
  }
  &-5 {
    width: 14%;
    min-width: 145px;
  }
}
.min-select {
  min-width: 125px;
}

.tooltip {
  &-date {
    font-size: 14px;
  }
}

</style>
